<script setup lang="ts">
import { mergeRegister } from "@lexical/utils";
import { COMMAND_PRIORITY_LOW, PASTE_COMMAND, type PasteCommandType } from "lexical";
import { useLexicalComposer } from "lexical-vue";
import { onMounted, onUnmounted } from "vue";

const props = defineProps<{
  isMultiline?: boolean;
}>();

const emit = defineEmits<{
  pasteMultilineText: [pastedText: string];
}>();

const editor = useLexicalComposer();

let unregisterListeners: () => void;

onMounted(() => {
  unregisterListeners = mergeRegister(
    editor.registerCommand<PasteCommandType>(
      PASTE_COMMAND,
      (event) => {
        const clipboardData = event instanceof ClipboardEvent ? event.clipboardData : null;
        if (!clipboardData?.types.includes("text/plain")) {
          return false;
        }
        const pastedText = clipboardData.getData("text");
        if (!pastedText.includes("\n")) {
          return false;
        }
        if (!props.isMultiline) {
          return false;
        }

        event.preventDefault();
        emit("pasteMultilineText", pastedText);
        return true;
      },
      COMMAND_PRIORITY_LOW
    )
  );
});

onUnmounted(() => {
  unregisterListeners?.();
});
</script>

<template>
  <slot />
</template>
